import type { MailboxInfo } from 'owa-client-types';
import type { SearchScope } from 'owa-search-service';
import { action } from 'satcheljs';

export interface REQUERY_GENWEB_ON_RELEVANCE_SORTActionMessage {
    queryString: string;
    mailboxInfo: MailboxInfo;
    searchScope: SearchScope;
    queryOnTypeSearchNumber: number;
}

export const requeryGenWebOnRelevanceSort: (
    queryString: string,
    mailboxInfo: MailboxInfo,
    searchScope: SearchScope,
    queryOnTypeSearchNumber: number
) => REQUERY_GENWEB_ON_RELEVANCE_SORTActionMessage = action(
    'REQUERY_GENWEB_ON_RELEVANCE_SORT',
    (
        queryString: string,
        mailboxInfo: MailboxInfo,
        searchScope: SearchScope,
        queryOnTypeSearchNumber: number
    ): REQUERY_GENWEB_ON_RELEVANCE_SORTActionMessage => ({
        queryString,
        mailboxInfo,
        searchScope,
        queryOnTypeSearchNumber,
    })
);
